module.exports = __webpack_public_path__ + "img/ESTJ.ba06b9e7.png";